var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8856 4.12988H3.20167C3.03941 4.12988 2.88379 4.19434 2.76904 4.30908C2.6543 4.42382 2.58984 4.57945 2.58984 4.74171V15.1428C2.58984 15.4674 2.71876 15.7786 2.94825 16.0081C3.17773 16.2376 3.48897 16.3665 3.81351 16.3665H17.2738C17.5983 16.3665 17.9096 16.2376 18.139 16.0081C18.3685 15.7786 18.4974 15.4674 18.4974 15.1428V4.74171C18.4974 4.57945 18.433 4.42382 18.3182 4.30908C18.2035 4.19434 18.0479 4.12988 17.8856 4.12988ZM16.3124 5.35354L10.5436 10.6421L4.77484 5.35354H16.3124ZM17.2738 15.1428H3.81351V6.13286L10.1299 11.9231C10.2428 12.0267 10.3904 12.0842 10.5436 12.0842C10.6969 12.0842 10.8445 12.0267 10.9574 11.9231L17.2738 6.13286V15.1428Z",
    fill: "#0D0E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.5da3f3b8579c8daa3889516842fb45c5.svg";
export { ForwardRef as ReactComponent };